// Persist and enforce locale routing for rewards/account flows.
(function localeSessionRoutingGuard() {
  const LOCALE_SESSION_KEY = 'tenaPreferredLocale';

  function getCurrentLocale() {
    if (typeof Shopify !== 'undefined' && Shopify && Shopify.locale) {
      return String(Shopify.locale).toLowerCase();
    }
    return '';
  }

  function stripLeadingLocale(pathname, localeCandidates) {
    const cleanPath = pathname || '/';
    const segments = cleanPath.split('/').filter(Boolean);
    if (!segments.length) return '/';

    const first = segments[0].toLowerCase();
    if (localeCandidates.includes(first)) {
      segments.shift();
      return '/' + segments.join('/');
    }
    return cleanPath;
  }

  function buildLocalizedPath(pathnameWithoutLocale, locale) {
    const basePath = pathnameWithoutLocale && pathnameWithoutLocale !== '' ? pathnameWithoutLocale : '/';
    if (!locale || locale === 'en') {
      return basePath;
    }
    return basePath === '/' ? '/' + locale : '/' + locale + basePath;
  }
 
  try {
    const pathname = window.location.pathname || '/';
    const currentLocale = getCurrentLocale();

    if (pathname.indexOf('/rewards-canada') !== -1 && currentLocale) {
      sessionStorage.setItem(LOCALE_SESSION_KEY, currentLocale);
    }

    const storedLocaleRaw = sessionStorage.getItem(LOCALE_SESSION_KEY) || '';
    const storedLocale = storedLocaleRaw.toLowerCase();
    if (!storedLocale) return;

    const localeCandidates = Array.from(new Set([
      'en',
      'fr',
      currentLocale,
      storedLocale
    ].filter(Boolean)));

    const pathWithoutLocale = stripLeadingLocale(pathname, localeCandidates);
    if (!/^\/account(?:\/|$)/.test(pathWithoutLocale)) return;

    const targetPath = buildLocalizedPath(pathWithoutLocale, storedLocale);
    const targetUrl = targetPath + window.location.search + window.location.hash;
    const currentUrl = pathname + window.location.search + window.location.hash;

    if (currentUrl !== targetUrl && (!currentLocale || currentLocale !== storedLocale || pathname !== targetPath)) {
      window.location.replace(targetUrl);
    }
  } catch (error) {
    console.warn('Locale session routing guard failed:', error);
  }
})();

let _miniCartKeydownHandler = null;
let _miniCartTriggerEl = null;
let _quickAddTriggerEl = null;

document.addEventListener("openCart", function () {

  // Only capture the trigger element if not already pre-set (e.g. from the quickAdd flow)
  if (!_miniCartTriggerEl) {
    _miniCartTriggerEl = document.activeElement;
  }

  refreshMiniCart();

  document.documentElement.classList.add('mini-cart-open');

  // Only capture activeElement as trigger if not already pre-set (e.g. from quickAdd flow)
  if (!_miniCartTriggerEl) {
    _miniCartTriggerEl = document.activeElement;
  }
  
  const miniCart = document.querySelector('.mini-cart');
  const miniCartOverlay = document.querySelector('.mini-cart__overlay');
  const miniCartClose = document.querySelector('.mini-cart__close');
  miniCart.classList.add('mini-cart--open');
  miniCartOverlay.classList.add('mini-cart__overlay--open');

  // Set up keyboard focus trap for the mini-cart
  const miniCartFocusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  if (_miniCartKeydownHandler) {
    document.removeEventListener('keydown', _miniCartKeydownHandler);
  }
  _miniCartKeydownHandler = function(e) {
    if (e.key === 'Escape') {
      closeMiniCart();
      return;
    }
    if (e.key !== 'Tab') return;
    const mc = document.querySelector('.mini-cart');
    if (!mc) return;
    const focusableEls = Array.from(mc.querySelectorAll(miniCartFocusableSelectors))
      .filter(el => el.offsetParent !== null);
    if (focusableEls.length === 0) return;
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      }
    } else {
      if (document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    }
  };
  document.addEventListener('keydown', _miniCartKeydownHandler);

  // Update all forms within the miniCart to submit via ajax

  // Helper to update cart UI after ajax change
  function refreshMiniCart() {
    // Re-fetch the mini-cart section and replace its HTML
    fetch('/?section_id=api-cart-items')
      .then(res => res.text())
      .then(html => {
        // Parse the returned HTML and extract the mini-cart section
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('.mini-cart');
        const newOverlay = doc.querySelector('.mini-cart__overlay');
        if (newSection && newOverlay) {
          document.querySelector('.mini-cart').innerHTML = newSection.innerHTML;
          //document.querySelector('.mini-cart__overlay').outerHTML = newOverlay.outerHTML;
        }
        // Re-attach event listeners for close button and forms
        attachMiniCartAjaxHandlers();
        focusMiniCart();
      });
  }

  function closeMiniCart() {
    if (_miniCartKeydownHandler) {
      document.removeEventListener('keydown', _miniCartKeydownHandler);
      _miniCartKeydownHandler = null;
    }
    document.querySelector('.mini-cart').classList.remove('mini-cart--open');
    document.querySelector('.mini-cart__overlay').classList.remove('mini-cart__overlay--open');
    document.documentElement.classList.remove('mini-cart-open');
    if (_miniCartTriggerEl && typeof _miniCartTriggerEl.focus === 'function') {
      _miniCartTriggerEl.focus();
    }
    _miniCartTriggerEl = null;
  }

  function focusMiniCart() {
    const mc = document.querySelector('.mini-cart');
    if (!mc) return;
    const focusEl = mc.querySelector(miniCartFocusableSelectors);
    if (focusEl) focusEl.focus();
  }

  function updateQuantity(lineItemkey, quantity) {
    console.log("updateQuantity", lineItemkey, quantity);
    const formData = new FormData();
    formData.append('id', lineItemkey);
    formData.append('quantity', quantity);

    fetch('/cart/change.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    }).then(() => {
      refreshMiniCart();
    });
  }

  function attachMiniCartAjaxHandlers() {
    // Attach close button event again (since HTML may have been replaced)
    const miniCartClose = document.querySelector('.mini-cart__close');
    if (miniCartClose) {
      miniCartClose.addEventListener('click', closeMiniCart);
    }
    miniCartOverlay.addEventListener('click', closeMiniCart);

    document.querySelectorAll('.btn-minus, .btn-plus').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log("btn-quantity", btn);
        const quantityControlParent = btn.closest('.quantity-control');
        if (quantityControlParent) {
          quantityControlParent.classList.add('loading');
        }
        updateQuantity(btn.dataset.lineItemKey, parseInt(btn.dataset.quantity));
      });
    });

    document.querySelectorAll('.remove button').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        btn.disabled = true;
        updateQuantity(btn.dataset.lineItemKey, 0);
      });
    });

    document.querySelectorAll('.btn--selling-plan').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        addSellingPlan(btn.dataset.lineItemIndex, btn.dataset.quantity, btn.dataset.sellingPlanId, btn);
      });
    });

    document.querySelectorAll('.cart-select-selling-plan').forEach(function(select) {
      select.addEventListener('change', function(e) {
        e.preventDefault();
        updateSellingPlan(select.dataset.lineItemIndex, select.dataset.quantity, select);
      });
    });

    document.querySelectorAll('.btn--upsell').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        btn.disabled = true;
        addUpsell(btn.dataset.upsellVariantId, btn);
      });
    });
  }

  function addUpsell(variantId, btn) {
    btn.disabled = true;
    addToCart(variantId, 1);
  }

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'items': [{
          'id': variantId,
          'quantity': quantity
        }]
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      refreshMiniCart();
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
  }

  function setSellingPlan(lineIndex, quantity, sellingPlanId) {
    //var $row = $('.ajaxcart__row[data-line="' + lineIndex + '"]').addClass('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'line': parseInt(lineIndex, 10),
        'selling_plan': parseInt(sellingPlanId, 10),
        'quantity': parseInt(quantity, 10)
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log("setSellingPlan", data);
      refreshMiniCart();
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
  }

  function updateSellingPlan(lineIndex, quantity, selector) {
    var sellingPlanId = selector.value;
    selector.disabled = true;
    if (sellingPlanId == "0") {
      removeSellingPlan(lineIndex, quantity);
    } else {
      setSellingPlan(lineIndex, quantity, sellingPlanId);
    }
  }
  
  function removeSellingPlan(lineIndex, quantity) {
    setSellingPlan(lineIndex, quantity, null);
  }

  function addSellingPlan(lineIndex, quantity, sellingPlanId, element) {
    element.disabled = true;
    setSellingPlan(lineIndex, quantity, sellingPlanId);
  }

  // Initial attach for current mini-cart
  attachMiniCartAjaxHandlers();
  focusMiniCart();

});

// Focus input on search open
document.querySelector('.header__right__icons--search').addEventListener('click', function(e) {
  const modal = document.querySelector('details-modal.header__search details');

  setTimeout(() => {
    if (modal && modal.hasAttribute('open')) {
      const searchField = document.querySelector('.search__input');
      if (searchField) {
        // iOS sometimes needs input to be temporarily disabled and re-enabled to focus and set cursor
        searchField.disabled = true;
        searchField.disabled = false;
        
        // Forcibly set cursor at end for iOS
        const val = searchField.value;
        searchField.value = '';
        searchField.value = val;
        searchField.focus();
        // Also try selecting the text to ensure cursor is visible
        searchField.setSelectionRange(val.length, val.length);
        
      }
    } 
  }, 300);
});

function quickAdd(handle) {
  _quickAddTriggerEl = document.activeElement;
  console.log('handle', handle);
  // First, close any existing modal if present
  let quickAddModal = document.getElementById('quick-add-modal');
  if (quickAddModal) {
    quickAddModal.parentNode.removeChild(quickAddModal);
  }

  // Fetch the quick add form via AJAX with section_id param
  fetch(`/products/${handle}?section_id=api-quick-add`)
    .then(response => {
      if (!response.ok) throw new Error('Network error');
      return response.text();
    })
    .then(html => {
      // Create modal wrapper
      quickAddModal = document.createElement('div');
      quickAddModal.id = 'quick-add-modal';
      quickAddModal.style.position = 'fixed';
      quickAddModal.style.top = '0';
      quickAddModal.style.left = '0';
      quickAddModal.style.width = '100vw';
      quickAddModal.style.height = '100vh';
      quickAddModal.style.background = 'rgba(0,0,0,0.5)';
      quickAddModal.style.display = 'flex';
      quickAddModal.style.alignItems = 'center';
      quickAddModal.style.justifyContent = 'center';
      quickAddModal.style.zIndex = '99999';

      // Popup content container
      const modalContent = document.createElement('div');
      modalContent.style.background = '#fff';
      modalContent.style.borderRadius = '8px';
      modalContent.style.maxWidth = '90vw';
      modalContent.style.maxHeight = '90vh';
      modalContent.style.overflow = 'auto';
      modalContent.style.position = 'relative';
      modalContent.innerHTML = html;

      // Add close button
      const closeBtn = document.createElement('button');
      closeBtn.innerHTML = '&times;';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.style.position = 'absolute';
      closeBtn.style.top = '8px';
      closeBtn.style.right = '12px';
      closeBtn.style.fontSize = '2rem';
      closeBtn.style.background = 'transparent';
      closeBtn.style.border = 'none';
      closeBtn.style.cursor = 'pointer';
      closeBtn.addEventListener('click', () => {
        closeQuickAddModal();
      });
      closeBtn.classList.add('quick-add__close');
      modalContent.appendChild(closeBtn);

      quickAddModal.appendChild(modalContent);

      function closeQuickAddModal() {
        if (quickAddModal.parentNode) quickAddModal.parentNode.removeChild(quickAddModal);
        if (_quickAddTriggerEl && typeof _quickAddTriggerEl.focus === 'function') {
          _quickAddTriggerEl.focus();
        }
        _quickAddTriggerEl = null;
      }

      // Dismiss when clicking outside popup content
      quickAddModal.addEventListener('click', (e) => {
        if (e.target === quickAddModal) {
          closeQuickAddModal();
        }
      });

      quickAddModal.setAttribute('tabindex', '-1');
      document.body.appendChild(quickAddModal);
      quickAddModal.focus();

      initQuickAdd(quickAddModal);

      // Trap focus within the modal
      const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

      // Move focus to the first interactive element once the modal has rendered
      setTimeout(() => {
        const focusEl = quickAddModal.querySelector(focusableSelectors);
        if (focusEl) focusEl.focus();
      }, 100);

      function handleModalKeydown(e) {
        if (e.key === 'Escape') {
          closeQuickAddModal();
          return;
        }
        if (e.key !== 'Tab') return;
        const focusableEls = Array.from(quickAddModal.querySelectorAll(focusableSelectors))
          .filter(el => el.offsetParent !== null);
        if (focusableEls.length === 0) return;
        const firstEl = focusableEls[0];
        const lastEl = focusableEls[focusableEls.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            e.preventDefault();
            lastEl.focus();
          }
        } else {
          if (document.activeElement === lastEl) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      }

      document.addEventListener('keydown', handleModalKeydown);

      // Remove focus trap listener once modal is removed from DOM
      const focusTrapObserver = new MutationObserver(() => {
        if (!document.contains(quickAddModal)) {
          document.removeEventListener('keydown', handleModalKeydown);
          focusTrapObserver.disconnect();
        }
      });
      focusTrapObserver.observe(document.body, { childList: true, subtree: true });
    })
    .catch(e => {
      console.log(e);
      console.log('Sorry, failed to load the product. Please try again.');
    });
}

function initQuickAdd(quickAddModal) {
  // Helper to update visibility/hiding logic for all option radio groups
  function updateOptionVisibility(productId) {
    const optionGroup = document.getElementById('product-options-' + productId);
    const variantSelector = document.getElementById('variant-selector-' + productId);

    if (!optionGroup || !variantSelector) return;

    console.log('variantSelector', variantSelector);
    variantSelector.addEventListener('change', (e) => {
      const selectedVar = variantSelector.querySelector('[value="' + variantSelector.value + '"]');
      const priceEl = quickAddModal.querySelector('.quick-add__price');
      const priceCompareEl = quickAddModal.querySelector('.quick-add__price-compare');
      priceEl.innerHTML = formatMoney(selectedVar.dataset.price);
      if (parseInt(selectedVar.dataset.price) < parseInt(selectedVar.dataset.comparePrice)) {
        priceCompareEl.innerHTML = formatMoney(selectedVar.dataset.comparePrice);
      } else {
        priceCompareEl.innerHTML = '';
      }
      console.log('selectedVar', selectedVar.dataset.price, selectedVar.dataset.comparePrice);
    });

    const fieldsets = Array.from(optionGroup.querySelectorAll('fieldset.quick-add__option'));
    if (fieldsets.length === 0) return;

    const variantOptions = Array.from(variantSelector.querySelectorAll('option[data-variant-title]'));
    const numFields = fieldsets.length;

    // 1. Find the selected value in the first radio group, or pick first available if checked one is hidden.
    let firstFieldset = fieldsets[0];
    let firstRadios = Array.from(firstFieldset.querySelectorAll('.product-card-option'));
    let checkedFirstRadio = firstRadios.find(r => r.checked);

    // If no checked or checked is hidden/disabled, select the first visible and enabled
    if (
      !checkedFirstRadio ||
      checkedFirstRadio.disabled ||
      (checkedFirstRadio.closest('div') && checkedFirstRadio.closest('div').style.display === 'none')
    ) {
      const visible = firstRadios.find(r => {
        const div = r.closest('div');
        return !r.disabled && div && div.style.display !== 'none';
      });
      if (visible) {
        visible.checked = true;
        checkedFirstRadio = visible;
      }
    }

    // For each fieldset, we'll control showing/hiding of its inputs based on the combined checked values before it
    // For the first fieldset, always show all possibilities that are possible (meaning, appear in some variant's first value)
    // For the rest, show/hide their radio buttons if there is any variant that has the combined values so far (from previous radios) + this option

    // Step 1: For each fieldset after the first, build current selection for previous
    fieldsets.forEach((fs, idx) => {
      const groupRadios = Array.from(fs.querySelectorAll('.product-card-option'));
      if (idx === 0) {
        // In first group, hide those with no valid variant across all combinations
        groupRadios.forEach(radio => {
          // Is there any variant option whose first value === this radio.value ?
          let found = variantOptions.some(opt => {
            // Instead of splitting on " / ", treat the first N slashes as separating options, and the rest as part of values.
            // So the compare for the first radio is still split[0]
            const split = (opt.getAttribute('data-variant-title') || '').split(' / ');
            return split[0] === radio.value && !opt.disabled;
          });
          const div = radio.closest('div');
          if (found) {
            radio.disabled = false;
            if (div) div.style.display = '';
          } else {
            radio.disabled = true;
            if (div) div.style.display = 'none';
          }
        });
      } else {
        // Others: show/hide each radio depending on previous choices so far plus this one

        // Build the path: checked value for each previous + this candidate
        let soFar = fieldsets.slice(0, idx).map(prevFs => {
          const checked = prevFs.querySelector('.product-card-option:checked');
          if (
            checked &&
            !checked.disabled &&
            checked.closest('div') &&
            checked.closest('div').style.display !== 'none'
          ) {
            return checked.value;
          } else {
            // Fallback: first visible and enabled
            const fb = Array.from(prevFs.querySelectorAll('.product-card-option')).find(r => {
              const div = r.closest('div');
              return !r.disabled && div && div.style.display !== 'none';
            });
            return fb ? fb.value : null;
          }
        });

        groupRadios.forEach(radio => {
          // For slashes in the value, compare with correct segment of variant title
          let candidateValues = soFar.concat([radio.value]);
          // To avoid problems with extra slashes in option values,
          // combine candidateValues with ' / ', and use the indexOf approach
          // instead of splitting the variant title all the way. We'll only split out as many segments as option groups.

          let found = variantOptions.some(opt => {
            const optionTitle = opt.getAttribute('data-variant-title') || '';
            // Split only as many segments as there are options
            let split = [];
            let remainder = optionTitle;
            for (let i = 0; i < numFields - 1; ++i) {
              let slashIdx = remainder.indexOf(' / ');
              if (slashIdx === -1) {
                split.push(remainder);
                remainder = '';
                break;
              }
              split.push(remainder.substring(0, slashIdx));
              remainder = remainder.substring(slashIdx + 3);
            }
            if (remainder.length > 0) split.push(remainder);
            // Now we have at most numFields segments, remainder could contain slashes

            // Only compare up to current idx + 1
            let matches = candidateValues.every((val, i) => {
              return split[i] === val;
            });
            return matches && !opt.disabled;
          });
          const div = radio.closest('div');
          if (found) {
            radio.disabled = false;
            if (div) div.style.display = '';
          } else {
            radio.disabled = true;
            if (div) div.style.display = 'none';
          }
        });
      }
    });

    // Step 2: For every group, if checked radio is hidden/disabled, check first visible/enabled instead
    fieldsets.forEach(fs => {
      const groupRadios = Array.from(fs.querySelectorAll('.product-card-option'));
      let checked = groupRadios.find(r => r.checked);
      if (
        !checked ||
        checked.disabled ||
        (checked.closest('div') && checked.closest('div').style.display === 'none')
      ) {
        // Select first visible/enabled radio
        const visible = groupRadios.find(r => {
          const div = r.closest('div');
          return !r.disabled && div && div.style.display !== 'none';
        });
        if (visible) visible.checked = true;
      }
    });

    // Step 3: Set variant select to match currently chosen radio values
    const selectedValues = fieldsets.map(fs => {
      const checked = fs.querySelector('.product-card-option:checked');
      if (
        checked &&
        !checked.disabled &&
        checked.closest('div') &&
        checked.closest('div').style.display !== 'none'
      ) {
        return checked.value;
      } else {
        // fallback to first visible/enabled
        const fallback = Array.from(fs.querySelectorAll('.product-card-option')).find(r => {
          const div = r.closest('div');
          return !r.disabled && div && div.style.display !== 'none';
        });
        return fallback ? fallback.value : '';
      }
    });

    // When matching to variant select, use the same "split only to number of options" rule
    // But here, selectedValues.join(' / ') is correct, as values may themselves have slashes.
    // So we look for an exact match in data-variant-title
    const variantName = selectedValues.join(' / ');
    const selectedOption = variantSelector.querySelector('[data-variant-title="' + variantName + '"]');
    if (selectedOption) {
      variantSelector.value = selectedOption.value;
      variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Make option labels keyboard-accessible since the radio inputs are visually hidden.
  // Runs after each updateOptionVisibility to stay in sync with shown/hidden states.
  function setupOptionLabels() {
    quickAddModal.querySelectorAll('fieldset.quick-add__option .product-card-option').forEach(radio => {
      const div = radio.closest('div');
      const label = radio.id ? quickAddModal.querySelector('label[for="' + radio.id + '"]') : null;
      if (!label) return;
      const isHidden = div && div.style.display === 'none';
      if (isHidden) {
        label.removeAttribute('tabindex');
      } else {
        label.setAttribute('tabindex', '0');
        if (!label.__quickAddKeydownBound) {
          label.__quickAddKeydownBound = true;
          label.addEventListener('keydown', function(e) {
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              radio.click();
            }
          });
        }
      }
    });
  }

  // Listen for radio changes in any group, update hiding/selection logic accordingly
  quickAddModal.querySelectorAll('.product-card-option').forEach(option => {
    option.addEventListener('change', function () {
      const productId = option.dataset.productId;
      updateOptionVisibility(productId);
      setupOptionLabels();
    });
  });

  // On initial render, update all quickadd forms/groups for correct visibility/selection and select default variant
  quickAddModal.querySelectorAll('[id^="product-options-"]').forEach(optionGroup => {
    const productId = optionGroup.id.replace("product-options-", "");
    updateOptionVisibility(productId);
  });
  setupOptionLabels();

  // Form submission handler for add to cart (single form)
  const quickAddForm = quickAddModal.querySelector('form[data-type="add-to-cart-form"]');
  if (quickAddForm && !quickAddForm.__quickAddBound) {
    quickAddForm.__quickAddBound = true;
    quickAddForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      const formData = new FormData(quickAddForm);

      // Swap display variant ID for the mapped bundle variant ID, if applicable
      const bundleMappingsEl = quickAddModal.querySelector('#bundle-variant-mappings');
      const bundleMappings = bundleMappingsEl ? JSON.parse(bundleMappingsEl.textContent) : {};
      const selectedVariantId = formData.get('id');
      if (bundleMappings[selectedVariantId]) {
        formData.set('id', String(bundleMappings[selectedVariantId]));
        formData.delete('selling_plan');
      }

      const submitBtn = quickAddForm.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        if (quickAddModal.parentNode) {
          quickAddModal.parentNode.removeChild(quickAddModal);
        }

        // Return focus to the element that opened the quickAdd modal when the cart closes
        _miniCartTriggerEl = _quickAddTriggerEl;
        _quickAddTriggerEl = null;

        // Open mini-cart. Try cart icon click, else custom event
        const cartIcon = document.querySelector('#cart-icon-bubble, [aria-controls="mini-cart-drawer"]');
        if (cartIcon) {
          cartIcon.click();
        } else {
          document.dispatchEvent(new Event('openCart'));
        }

      } catch (e) {
        console.log('Failed to add to cart. Please try again.');
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }


}

function updateDeliveryText() {
  const subscriptionOffer = document.querySelector('og-offer');
  let delivery = "One-time purchase";
  if (subscriptionOffer) {
    const isSubcription = subscriptionOffer.subscribed;
    if (isSubcription) {
      const subscriptionSelector = document.querySelector('og-select-frequency');
      if (subscriptionSelector.productFrequencies && subscriptionSelector.productFrequencies.frequencies) {
        subscriptionSelector.productFrequencies.frequencies.forEach((frequency, index) => {
          if (frequency === subscriptionOffer.frequency) {
            delivery = subscriptionSelector.productFrequencies.frequenciesText[index];
          }
        });
      }
      delivery = "Delivered every " + delivery;
    }
  }
  const deliveryTexts = document.querySelectorAll('.product__floating-form__delivery-text');
  if (deliveryTexts.length > 0) {
    deliveryTexts.forEach(deliveryText => {
      deliveryText.innerHTML = delivery;
    });
  }
}


function setupProductPageVariantLabels() {
  document.querySelectorAll('variant-selects').forEach(function(variantSelects) {
    function updateLabels() {
      variantSelects.querySelectorAll('input[type="radio"]').forEach(function(radio) {
        const label = radio.id ? variantSelects.querySelector('label[for="' + radio.id + '"]') : null;
        // Always remove radios from natural tab order — labels take over
        radio.setAttribute('tabindex', '-1');
        if (!label) return;
        const isHidden = label.style.display === 'none';
        if (isHidden) {
          label.removeAttribute('tabindex');
        } else {
          label.setAttribute('tabindex', '0');
          if (!label.__variantKeydownBound) {
            label.__variantKeydownBound = true;
            label.addEventListener('keydown', function(e) {
              if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                radio.click();
              }
            });
          }
        }
      });
    }

    updateLabels();

    variantSelects.addEventListener('change', function() {
      setTimeout(updateLabels, 50);
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const floatingFormBtn = document.querySelector('.floating-form__submit');
  if (floatingFormBtn ) {
    floatingFormBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const mainFormBtn = document.querySelector('.product-form__submit');
      mainFormBtn.click();
      console.log('floating form button clicked');
    });
  }
  const floatingForm = document.querySelector('.product__floating-form');
  if (floatingForm) {
    setTimeout(() => {
      updateDeliveryText();
        floatingForm.classList.add('active');
    }, 2000);
  }

  initPageFlyBundleMapping();
  setupProductPageVariantLabels();
});

function initPageFlyBundleMapping() {
  const mappingsEl = document.getElementById('page-bundle-variant-mappings');
  const availabilityEl = document.getElementById('page-bundle-availability-overrides');

  // Only activate on pages where the section has been added via theme customizer
  if (!mappingsEl && !availabilityEl) return;

  const bundleMappings = mappingsEl ? JSON.parse(mappingsEl.textContent) : {};
  const availabilityOverrides = availabilityEl ? JSON.parse(availabilityEl.textContent) : {};
  const bundleVariantValues = new Set(Object.values(bundleMappings).map(String));

  // PageFly's ATC button is type="button" with name="add", not type="submit"
  function getAtcButton(form) {
    return form.querySelector('button[name="add"], [type="submit"]');
  }

  // Returns the display variant ID for the form's current selection,
  // whether or not the hidden input has already been swapped to a bundle ID.
  function getDisplayVariantId(idInput) {
    return idInput.dataset.pfDisplayVariantId || idInput.value;
  }

  function setAvailableState(atcBtn, availableText) {
    atcBtn.disabled = false;
    atcBtn.textContent = availableText;
  }

  document.querySelectorAll('form.pf-product-form').forEach(function(form) {
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    const atcBtn = getAtcButton(form);
    const soldOutText = atcBtn ? (atcBtn.dataset.soldout || '') : '';

    // Resolve the "Add to Cart" label from PageFly's data attribute, or fall back
    // to reading whichever form's button isn't currently showing the sold-out text.
    function resolveAvailableText() {
      if (atcBtn) {
        const addText = atcBtn.dataset.add;
        if (addText) return addText;
        const current = atcBtn.textContent.trim();
        if (current && current !== soldOutText) return current;
      }
      // Try the other form on the page
      const other = document.querySelector('form.pf-product-form button[name="add"]');
      if (other && other !== atcBtn) {
        const t = other.textContent.trim();
        if (t && t !== soldOutText) return t;
        if (other.dataset.add) return other.dataset.add;
      }
      return 'Add To Cart';
    }

    // Synchronously ensure the hidden input holds the bundle variant ID and the
    // button is in the correct state. Called in the capture-phase click handler
    // so it runs before PageFly reads the form.
    function ensureBundleSwap() {
      const displayVariantId = getDisplayVariantId(idInput);
      const bundleVariantId = bundleMappings[displayVariantId];
      if (bundleVariantId) {
        idInput.dataset.pfDisplayVariantId = displayVariantId;
        idInput.value = String(bundleVariantId);
      }
    }

    // Update button state to reflect the current variant selection
    function updateButtonState() {
      if (!atcBtn) return;
      const displayVariantId = getDisplayVariantId(idInput);
      const bundleVariantId = bundleMappings[displayVariantId];
      if (bundleVariantId) {
        const isAvailable = availabilityOverrides[displayVariantId];
        if (isAvailable !== false) {
          setAvailableState(atcBtn, resolveAvailableText());
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = soldOutText || 'Sold out';
        }
      }
      // Non-bundle variant: leave PageFly in control
    }

    // Run once on page load for the default variant
    updateButtonState();

    // Capture-phase click: swap the hidden input value to the bundle ID BEFORE
    // PageFly's own click handler reads it and builds the cart request.
    if (atcBtn) {
      atcBtn.addEventListener('click', function() {
        ensureBundleSwap();
      }, true); // capture phase
    }

    // Watch for PageFly updating the hidden input via setAttribute (variant change)
    const inputObserver = new MutationObserver(function() {
      const newValue = idInput.value;
      if (bundleMappings[newValue]) {
        // PageFly wrote a display variant ID — store it and schedule a state update
        idInput.dataset.pfDisplayVariantId = newValue;
        setTimeout(updateButtonState, 50);
      } else if (!bundleVariantValues.has(newValue)) {
        // PageFly wrote a non-bundle, non-swapped variant — clear stored ID
        idInput.dataset.pfDisplayVariantId = '';
      }
    });
    inputObserver.observe(idInput, { attributes: true, attributeFilter: ['value'] });

    // Watch the ATC button's disabled attribute: if PageFly re-disables it after
    // we enabled it, restore the correct state.
    // Use setTimeout(0) so PageFly can finish updating the button text first,
    // allowing us to detect "Adding..." / "Thank you!" and leave those states alone.
    if (atcBtn) {
      let reEnabling = false;
      const btnObserver = new MutationObserver(function() {
        if (reEnabling || !atcBtn.disabled) return;
        setTimeout(function() {
          if (!atcBtn.disabled) return; // PageFly already re-enabled (e.g. after "Thank you!")
          const currentText = atcBtn.textContent.trim();
          const addingText = atcBtn.dataset.adding || '';
          const addedText = atcBtn.dataset.added || '';
          // PageFly is mid-add — don't interfere
          if (currentText === addingText || currentText === addedText) return;
          const displayVariantId = getDisplayVariantId(idInput);
          if (displayVariantId && bundleMappings[displayVariantId]) {
            const isAvailable = availabilityOverrides[displayVariantId];
            if (isAvailable !== false) {
              reEnabling = true;
              setAvailableState(atcBtn, resolveAvailableText());
              reEnabling = false;
            }
          }
        }, 0);
      });
      btnObserver.observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });
    }

    // Fallback: variant select/radio change
    form.addEventListener('change', function(e) {
      if (e.target && (e.target.tagName === 'SELECT' || e.target.type === 'radio')) {
        idInput.dataset.pfDisplayVariantId = '';
        setTimeout(updateButtonState, 50);
      }
    });
  });
}
